import isEqual from 'lodash/isEqual';
import get from 'lodash/get';
import { useState, useEffect, useMemo } from 'react';

import Ivr from 'src/models/Ivrs/Ivr';
import TreeData from 'src/presentation/components/pages/ivr/components/ivrTree/models/TreeData';
import { IvrConfig, IvrConfiguration } from 'src/presentation/components/pages/ivr/components/ivrTree/config/ivrConfig';
import { transform } from 'src/presentation/components/pages/ivr/components/ivrTree/helpers/nodesHelper';

const useTransformer = (data: IvrConfiguration, locationState) => {
  const [inputData, setInputData] = useState<Ivr | null>(data);
  const [treeData, setTreeData] = useState<TreeData | null>(null);
  const [ivrFrameSize, setIvrFrameSize] = useState<any>(null);

  const theSameNodes = useMemo(
    () =>
      get(inputData, 'rootNodeId') === get(data, 'rootNodeId') &&
      isEqual(get(inputData, 'nodesMap'), get(data, 'nodesMap')),
    [inputData, data]
  );

  useEffect(() => {
    if (data) {
      setInputData(data);

      if (!theSameNodes) {
        const ivrConfig = new IvrConfig(data);
        const [treeData, ivrFrameSize] = transform(ivrConfig, locationState);

        setIvrFrameSize(ivrFrameSize);
        setTreeData(treeData);
      }
    }
  }, [data, locationState, setInputData, setIvrFrameSize, setTreeData, theSameNodes]);

  return { treeData, ivrFrameSize, setInputData };
};

export default useTransformer;
